import { UMR } from '../../urbanmap/_components';
import { PLAN } from '../proposition-c/tokens';

/** Plan tokens (shared with proposition-c) + a few states specific to this prototype. */
export const PC = {
  ...PLAN,
  dangerBg: 'var(--nj-core-color-red-100, #fdecec)',
  dangerBorder: 'var(--nj-core-color-red-400, #f08c8c)',
  dangerText: 'var(--nj-core-color-red-700, #b2201c)',
  /** Map dataset colours (hex allowed). */
  draw: '#007bc5',
  included: '#00726d',
  excluded: '#b8c3cc',
  outline: '#00726d',
} as const;

export { UMR };

export const STUDIO_HEADER = 48;

export const card = {
  background: UMR.white,
  border: `1px solid ${UMR.border}`,
  borderRadius: 8,
  padding: 12,
} as const;

export const caption = { fontSize: 12, lineHeight: '16px', color: UMR.textSecondary } as const;
